import { useState, useEffect, TouchEventHandler } from 'react'
import cx from 'classnames'

import { ImageLink } from 'lib/_types'

import { ImageItem } from './ImageItem'

import './style.scss'

const TIMEOUT = 2000
const SWIPE_DISTANCE = 50

export const ImageSlider = ({ data }: { data: ImageLink[] }) => {
  const [active, setActive] = useState(0)
  const [hover, setHover] = useState(false)
  const [touchStart, setTouchStart] = useState<number>()
  const [touchEnd, setTouchEnd] = useState<number>()

  useEffect(() => {
    setActive(Math.min(data.length - 1, active))
  }, [data.length])

  useEffect(() => {
    if (hover) return

    const timeout = setTimeout(() => {
      setActive((active + 1) % data.length)
    }, TIMEOUT)

    return () => {
      clearTimeout(timeout)
    }
  }, [active, hover])

  const onTouchStart: TouchEventHandler<HTMLDivElement> = (e) => {
    setTouchEnd(undefined)
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove: TouchEventHandler<HTMLDivElement> = (e) =>
    setTouchEnd(e.targetTouches[0].clientX)

  const onTouchEnd = () => {
    const diff = touchStart - touchEnd
    if (isNaN(diff) || Math.abs(diff) < SWIPE_DISTANCE) return

    const next = (active + 1) % data.length
    const previous = (active - 1 + data.length) % data.length

    setActive(diff > 0 ? next : previous)
  }

  return (
    <div
      className="ImageSlider"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className="ImageSlider__list"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {data.map((image, index) => {
          let state = ''

          if (index === active) state = 'active'
          else if (index > active) state = 'next'
          else if (index < active) state = 'previous'

          return <ImageItem key={image.id} {...image} state={state} />
        })}
      </div>
      <div className="ImageSlider__navigation">
        {data.map((_, index) => (
          <div
            key={index}
            className={cx('ImageSlider__navigation__button', {
              'ImageSlider__navigation__button--active': index === active,
            })}
            onClick={() => setActive(index)}
          />
        ))}
      </div>
    </div>
  )
}
